import * as React from 'react';

import { parse } from 'papaparse';

import { useAlert } from 'react-alert'

import { sessionStore, TFolderCodes, MANUALLY_ADDED_FOLDER, QrLinkVendor } from '../../services';

import './upload-button.component.scss';

const INVALID_CODE = 'INVALID_CODE';

export const UploadButton: React.FunctionComponent<{}> = () => {
	let input = React.useRef();
	const alert = useAlert();
	const [qrVendor, setQrVendor] = React.useState<QrLinkVendor>(() => sessionStore.qrLinkVendor$.value);

	React.useEffect(() => {
		const sub = sessionStore.qrLinkVendor$.subscribe(setQrVendor);
		return () => sub.unsubscribe();
	}, []);

	const CODE_LEN = 6;
	const formatId = (id: string): string => {
		const s = id.trim();
		if (!s.length || s.length > CODE_LEN || !/^\d+$/.test(s)) {
			return INVALID_CODE;
		}
		if (s.length === CODE_LEN) return s;
		return `${'0'.repeat(CODE_LEN - s.length)}${s}`;
	};

	const parseCSV = (e: any) => {
		if (!e.target.files[0]) return;
		parse(e.target.files[0], {
			complete: result => {
				if (result.data.length) {
					const folderName = e.target.files[0].name.split('.')[0];
					const rows = result.data as string[][];
					let skipped = 0;
					const codes: string[] = [];
					for (const row of rows) {
						const raw = row[0];
						if (raw === undefined || raw === null || String(raw).trim() === '') continue;
						const formatted = formatId(String(raw));
						if (formatted === INVALID_CODE) {
							skipped += 1;
							continue;
						}
						codes.push(formatted);
					}
					if (!codes.length) {
						if (skipped > 0) {
							alert.show(
								'В файле нет корректных числовых кодов (только цифры, до 6 символов в номере).',
							);
						} else {
							alert.show('Проверьте загружаемый файл. Возможно он пуст или имеет некорректный формат.');
						}
						return;
					}
					if (skipped > 0) {
						alert.show(`Пропущено строк с некорректным кодом: ${skipped}`);
					}

					const folders: TFolderCodes = { ...sessionStore.listOfCodes$.value };
					if (folders.hasOwnProperty(folderName)) {
						folders[folderName] = [...folders[folderName], ...codes];
					} else {
						folders[folderName] = [...codes];
					}
					sessionStore.listOfCodes$.next(folders);
				} else {
					alert.show('Проверьте загружаемый файл. Возможно он пуст или имеет некорректный формат.');
				}
			},
		});
	};

	const addCode = () => {
		// @ts-ignore
		const code = formatId(input.current.value);
		if (code === INVALID_CODE) {
			alert.error('Код только из цифр, от 1 до 6 символов (короче 6 — дополняется нулями слева).');
			return;
		}
		const folders: TFolderCodes = { ...sessionStore.listOfCodes$.value };
		if (folders.hasOwnProperty(MANUALLY_ADDED_FOLDER)) {
			folders[MANUALLY_ADDED_FOLDER] = [...folders[MANUALLY_ADDED_FOLDER], code];
		} else {
			folders[MANUALLY_ADDED_FOLDER] = [code];
		}
		sessionStore.listOfCodes$.next(folders);
		// @ts-ignore
		input.current.value = '';
		alert.success(`Код ${code} успешно добавлен`);
	};

	const onVendorChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const v = e.target.value;
		if (v === QrLinkVendor.Yandex || v === QrLinkVendor.Yango) {
			sessionStore.qrLinkVendor$.next(v);
		}
	};

	return (
		<div className="upload-block">
			<div className="vendor-select-row">
				<label className="vendor-select-label" htmlFor="qr-link-vendor">
					Платформа
				</label>
				<select
					id="qr-link-vendor"
					className="vendor-select"
					value={qrVendor}
					onChange={onVendorChange}>
					<option value={QrLinkVendor.Yandex}>Yandex</option>
					<option value={QrLinkVendor.Yango}>Yango</option>
				</select>
			</div>
			<div className="manually-add">
				{/* @ts-ignore */}
				<input ref={input} type="text" />
				<button className="add-button" onClick={() => addCode()}>Добавить</button>
			</div>
			<div>
				<label className="upload-button" htmlFor="file">
					<span>Загрузить файл</span>
					<input id="file" type="file" onChange={e => parseCSV(e)} style={{ display: 'none' }} />
				</label>
			</div>
		</div>
	);
};
